import { useEffect, useState } from "react";
import { clearStorageKeepingAttribution } from "../../../../utils/attribution";
import {
  IconLayoutDashboard,
  IconBriefcase,
  IconUsers,
  IconUserCircle,
  IconCreditCard,
  IconMessageCircle,
  IconBuilding,
  IconChevronDown,
  IconLogout,
  IconHelpCircle,
} from "@tabler/icons-react";
import styles from "./sidebar.module.css";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const ICON_SIZE = 18;
const NAV_ITEMS = [
  {
    icon: IconLayoutDashboard,
    label: "Dashboard",
    link: "/client-activity-summary",
  },
  { icon: IconBriefcase, label: "My Jobs", link: "/client-jobs" },
  { icon: IconUsers, label: "Talents", link: "/talent" },
  { icon: IconUserCircle, label: "My Profile", link: "/personal-profile" },
  {
    icon: IconCreditCard,
    label: "Subscription & Payment",
    link: "/subscription-payment",
  },
  { icon: IconMessageCircle, label: "Messages", link: "/client-messages" },
];

export default function ClientSidebar({
  collapsed,
  mobileOpen,
  onOverlayClick,
  data,
}) {
  const [subOpen, setSubOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const companySectionActive =
    location.pathname.startsWith("/company-profile") ||
    location.pathname.startsWith("/team-management");

  useEffect(() => {
    if (companySectionActive) setSubOpen(true);
  }, [companySectionActive]);

  const sidebarClasses = [
    styles.sidebar,
    collapsed ? styles.sidebarCollapsed : "",
    mobileOpen ? styles.sidebarMobileOpen : "",
  ]
    .filter(Boolean)
    .join(" ");

  const logout = () => {
    clearStorageKeepingAttribution();
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`${styles.sidebarOverlay} ${mobileOpen ? styles.sidebarOverlayOpen : ""}`}
        onClick={onOverlayClick}
      />

      <nav className={sidebarClasses} id="sidebar" aria-label="Main navigation">
        <div className={styles.sidebarNav}>
          {/* Main nav items */}
          {NAV_ITEMS.map(({ icon: Icon, label, link }) => (
            <NavLink
              key={label}
              to={link}
              className={({ isActive }) =>
                isActive
                  ? `${styles.navItemActive} ${styles.navItem}`
                  : styles.navItem
              }
            >
              <Icon size={ICON_SIZE} />
              <span className={styles.navText}>{label}</span>
            </NavLink>
          ))}

          {/* Company Profile (with submenu) */}
          <button
            className={`${styles.navItem}`}
            aria-expanded={subOpen}
            onClick={() => setSubOpen((p) => !p)}
          >
            <IconBuilding size={ICON_SIZE} />
            <span className={styles.navText}>Company Profile</span>
            <IconChevronDown
              size={14}
              className={styles.navItemChevron}
              style={{
                transform: subOpen ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 0.2s",
              }}
            />
          </button>

          <div
            className={`${styles.navSub} ${subOpen ? styles.navSubOpen : ""}`}
          >
            <NavLink
              to="/company-profile"
              className={({ isActive }) =>
                isActive
                  ? `${styles.navSubItemActive} ${styles.navSubItem}`
                  : styles.navSubItem
              }
            >
              Company Profile
            </NavLink>
            <NavLink
              to="/team-management"
              className={({ isActive }) =>
                isActive
                  ? `${styles.navSubItemActive} ${styles.navSubItem}`
                  : styles.navSubItem
              }
            >
              Team Management
            </NavLink>
          </div>

          <div className={styles.navCollapsedDivider} />

          {/* Account section */}
          <div className={styles.navLabel}>Account</div>
          <button onClick={logout} className={styles.navItem}>
            <IconLogout size={ICON_SIZE} />
            <span className={styles.navText}>Logout</span>
          </button>

          {data?.trialStatus?.isActive && (
            <li className={styles.fill}>
              <button
                className={styles.freeTrialBtn}
                style={{
                  background: "#fee8bc",
                  color: "#e19606",
                  borderRadius: "4px",
                  border: "none",
                  padding: "6px 12px",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "400",
                  width: "auto",
                  minWidth: "70px",
                  marginLeft: "10%",
                }}
              >
                <span>Free Trial</span>
              </button>
            </li>
          )}
          <Link to="/client-report" className={styles.navItem}>
            <IconHelpCircle size={ICON_SIZE} />
            <span className={styles.navText}>Support</span>
          </Link>
        </div>
      </nav>
    </>
  );
}
